import { useState } from 'react'

import { Modal } from '@/shared'
import { type ISectionRulesWrapper, type IRuleSection } from '@App/types/servicesTypes'

import { ChosenRule } from './ChosenRule/ChosenRule'
import { RulesOptions } from './RulesOptions/RulesOptions'
import style from './SectionRulesModal.module.scss'

interface IProps {
    isFetching: boolean
    sectionRules: ISectionRulesWrapper
    onSetSectionRules: (sectionRules: ISectionRulesWrapper | null) => void
    onChangeRules: (dto: ISectionRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
}

export const SectionRulesModal = (props: IProps) => {
    const { isFetching, sectionRules, onSetSectionRules, onChangeRules } = props
    const [chosen, setChosen] = useState<IRuleSection | null>(null)
    const [showAdd, setShowAdd] = useState<boolean>(false)

    const onClose = () => {
        if (chosen) {
            setChosen(null)
        } else {
            setChosen(null)
            onSetSectionRules(null)
        }
    }

    return (
        <Modal show={!!sectionRules} onClose={onClose}>
            <div className={style.container}>
                {!showAdd && sectionRules.sections.length < 1 && (
                    <div className={style.empty}>
                        <div className={style.title}>
                            <span>Список пуст</span>
                        </div>
                    </div>
                )}
                {!chosen && (
                    <RulesOptions
                        isFetching={isFetching}
                        showAdd={showAdd}
                        setShowAdd={setShowAdd}
                        sectionRules={sectionRules}
                        setChosen={setChosen}
                        onChangeRules={onChangeRules}
                        onSetSectionRules={onSetSectionRules}
                    />
                )}
                {chosen && (
                    <ChosenRule
                        isFetching={isFetching}
                        sectionRules={sectionRules}
                        setChosen={setChosen}
                        onChangeRules={onChangeRules}
                        {...chosen}
                    />
                )}
            </div>
        </Modal>
    )
}
